var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled, { css } from "styled-components";
var getSize = function (size) {
    switch (size) {
        case "xxxl":
            return "6.4rem";
        case "xxl":
            return "4.8rem";
        case "xl":
            return "3.2rem";
        case "l":
            return "2.4rem";
        case "m":
            return "1.6rem";
        case "s":
            return "0.8rem";
        default:
            return "1.6rem";
    }
};
export var Spacer = styled.div.attrs({
    className: "Spacer",
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (props) {
    var size = "1.6rem";
    if (props.size) {
        if (typeof props.size === "number") {
            size = props.size + "rem";
        }
        else {
            size = getSize(props.size);
        }
    }
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      height: ", ";\n      min-height: ", ";\n    "], ["\n      height: ", ";\n      min-height: ", ";\n    "])), size, size);
});
var templateObject_1, templateObject_2;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU3BhY2VyU3R5bGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiU3BhY2VyU3R5bGVzLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7O0FBQUEsT0FBTyxNQUFNLEVBQUUsRUFBRSxHQUFHLEVBQUUsTUFBTSxtQkFBbUIsQ0FBQztBQUdoRCxJQUFNLE9BQU8sR0FBRyxVQUFDLElBQWE7SUFDNUIsUUFBUSxJQUFJLEVBQUU7UUFDWixLQUFLLE1BQU07WUFDVCxPQUFPLFFBQVEsQ0FBQztRQUNsQixLQUFLLEtBQUs7WUFDUixPQUFPLFFBQVEsQ0FBQztRQUNsQixLQUFLLElBQUk7WUFDUCxPQUFPLFFBQVEsQ0FBQztRQUNsQixLQUFLLEdBQUc7WUFDTixPQUFPLFFBQVEsQ0FBQztRQUNsQixLQUFLLEdBQUc7WUFDTixPQUFPLFFBQVEsQ0FBQztRQUNsQixLQUFLLEdBQUc7WUFDTixPQUFPLFFBQVEsQ0FBQztRQUNsQjtZQUNFLE9BQU8sUUFBUSxDQUFDO0tBQ25CO0FBQ0gsQ0FBQyxDQUFDO0FBRUYsTUFBTSxDQUFDLElBQU0sTUFBTSxHQUFHLE1BQU0sQ0FBQyxHQUFHLENBQUMsS0FBSyxDQUFDO0lBQ3JDLFNBQVMsRUFBRSxRQUFRO0NBQ3BCLENBQUMsK0VBQVUsTUFDUixFQWVGLElBQ0QsS0FoQkcsVUFBQSxLQUFLO0lBQ0wsSUFBSSxJQUFJLEdBQUcsUUFBUSxDQUFDO0lBRXBCLElBQUksS0FBSyxDQUFDLElBQUksRUFBRTtRQUNkLElBQUksT0FBTyxLQUFLLENBQUMsSUFBSSxLQUFLLFFBQVEsRUFBRTtZQUNsQyxJQUFJLEdBQUcsS0FBSyxDQUFDLElBQUksR0FBRyxLQUFLLENBQUM7U0FDM0I7YUFBTTtZQUNMLElBQUksR0FBRyxPQUFPLENBQUMsS0FBSyxDQUFDLElBQUksQ0FBQyxDQUFDO1NBQzVCO0tBQ0Y7SUFFRCxPQUFPLEdBQUcseUhBQUEsa0JBQ0UsRUFBSSx1QkFDQSxFQUFJLFNBQ25CLEtBRlcsSUFBSSxFQUNBLElBQUksRUFDbkI7QUFBQSxDQUFDLENBRUwsQ0FBQyJ9